module.exports = __webpack_public_path__ + "img/x-circle.1a77c047.svg";